export function scrollToElement(elementId) {
  const htmlElement = document.getElementById(elementId)
  if (!htmlElement) return

  window.scrollTo({
    top: htmlElement.getBoundingClientRect().y + window.scrollY - 80,
    left: 0,
    behavior: 'smooth'
  })
  htmlElement.focus()
}

export const labelLiterals = {
  adTitle: 'PUBLISH_AD.FB.AD_TITLE.LABEL',
  bodyTypeDoors: 'COMMON.PLURALS.BODY_TYPE',
  colour: 'PUBLISH_AD.FB.COLORS.LABEL',
  comments: 'PUBLISH_AD.COMMENTS.TITLE',
  duplicatedPhone: 'COMMON.PHONE',
  emptyPhoneField: 'COMMON.PHONE',
  fuelId: 'COMMON.FUEL',
  invalidPhoneFieldFormat: 'COMMON.PHONE',
  km: 'COMMON.KMS',
  makeId: 'COMMON.MAKE',
  modelId: 'COMMON.PLURALS.MODEL',
  phone: 'COMMON.PHONE',
  price: 'COMMON.PRICE',
  province: 'COMMON.PLURALS.PROVINCE',
  transmissionTypeId: 'COMMON.TRANSMISSION_TYPE',
  versionId: 'COMMON.VERSION',
  wrongZipCode: 'FORM.ZIP_CODE_NOT_VALID_ERROR',
  year: 'COMMON.YEAR',
  zipCode: 'COMMON.POSTAL_CODE'
}

export const phoneErrorTypes = ['duplicatedPhoneNumber', 'emptyPhoneField', 'invalidPhoneFieldFormat']
